export type ViewKey = 'kpis' | 'suppliers' | 'warehouse' | 'transportation' | 'onboarding';

interface NavItem {
  key: ViewKey;
  label: string;
  icon: string;
}

const NAV: NavItem[] = [
  { key: 'kpis', label: 'KPI Summary', icon: '📊' },
  { key: 'suppliers', label: 'Supplier Health', icon: '🏭' },
  { key: 'warehouse', label: 'Warehouse Ops', icon: '📦' },
  { key: 'transportation', label: 'Transportation', icon: '🚚' },
  { key: 'onboarding', label: 'Onboarding', icon: '🧩' },
];

interface SidebarProps {
  active: ViewKey;
  onSelect: (key: ViewKey) => void;
}

export function Sidebar({ active, onSelect }: SidebarProps) {
  return (
    <aside className="flex w-60 shrink-0 flex-col border-r border-slate-200 bg-white">
      <div className="flex items-center gap-2 px-6 py-5">
        <span className="text-2xl">⛓️</span>
        <div>
          <div className="text-lg font-semibold leading-tight text-slate-900">Jupiter</div>
          <div className="text-[10px] uppercase tracking-wider text-slate-400">Supply Chain OS</div>
        </div>
      </div>
      <nav className="flex-1 space-y-1 px-3">
        {NAV.map((item) => {
          const isActive = item.key === active;
          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onSelect(item.key)}
              className={`flex w-full items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition ${
                isActive ? 'bg-brand-50 text-brand-700' : 'text-slate-600 hover:bg-slate-50'
              }`}
            >
              <span aria-hidden>{item.icon}</span>
              {item.label}
            </button>
          );
        })}
      </nav>
      <div className="border-t border-slate-100 px-4 py-4">
        <a
          href="/demo"
          className="flex items-center justify-between rounded-lg bg-slate-900 px-3 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800"
        >
          <span>7-minute demo</span>
          <span aria-hidden>→</span>
        </a>
        <p className="mt-3 px-2 text-xs text-slate-400">v0.1.0 · demo data</p>
      </div>
    </aside>
  );
}
